var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.07 15.343V4.68h7.471l3.214 3.176h12.131v7.568"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.78,
    cy: 9.11,
    r: 1.399
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_dark_dot",
    d: "M37.224 14.304H5.41a1.5 1.5 0 00-1.5 1.5v22.269a1.5 1.5 0 001.5 1.5h31.814a1.5 1.5 0 001.5-1.5V15.804a1.5 1.5 0 00-1.5-1.5zM26.818 22.45h-11a1.6 1.6 0 110-3.2h11a1.6 1.6 0 110 3.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFilled);
export default __webpack_public_path__ + "static/media/archiveFilled.4a1768e32cd01433dc2abb90032c9d11.svg";
export { ForwardRef as ReactComponent };